// extracted by mini-css-extract-plugin
module.exports = {"title":"msBDikOprKcdg_K9qxlc4","lg":"_1MmtP8pN1lqEuaiez6Xk-6","md":"HqxPnQUeFaoHmgTpVSXEC","sm":"_3L00XcDc2bl620XeuAM71N"};